import { POLICIES } from "@/policies";
import { MaybeLink } from "../layout/MaybeLink";
import { StagePage } from "../layout/StagePage";
import { GoesTo } from "../layout/wayfinding";
import { BackToClients, ClientsPageFrame } from "./ClientsLayout";

const LEDE =
  "This section provides important legal documents and policies that govern your use of our website and services. Please take a moment to read through them.";

/**
 * The legal documents, one card each, beside the clients rather than under one.
 *
 * The cards are what the app holds in `POLICIES`, so a document added there
 * gets its card here without this page changing. Each item stays still and
 * the card inside it lifts, for the reason `LiftingItem` gives. The design's
 * border is the card's own colour, so the card is drawn without one and a
 * pixel more padding. The design marks a card with a way out of the app, but
 * each document opens inside it, so the card wears the chevron every link
 * into a page does.
 */
export function LegalPage() {
  return (
    <ClientsPageFrame crumbs={[]}>
      <StagePage
        testId="legal-page"
        back={<BackToClients />}
        title="Legal"
        lede={LEDE}
      >
        <ul
          aria-label="Legal documents"
          className="mt-[18px] grid grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-4"
        >
          {POLICIES.map((policy) => (
            <li key={policy.id} className="group">
              <MaybeLink
                to={`/policies/${policy.id}`}
                className="flex min-h-[78px] items-start justify-between gap-3.5 rounded-md bg-sidebar p-[19px] text-white transition-[background-color,box-shadow,transform] duration-200 group-hover:-translate-y-0.5 group-hover:bg-primary group-hover:shadow-[0_10px_26px_rgba(15,0,27,0.18)] focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:outline-none"
              >
                <b className="text-[14px] leading-[1.35] font-bold text-pretty">
                  {policy.document.title}
                </b>
                <GoesTo className="size-[18px] text-white/80" />
              </MaybeLink>
            </li>
          ))}
        </ul>
      </StagePage>
    </ClientsPageFrame>
  );
}
